import React, { Component, Fragment } from "react";

import "./index.scss";
import desktop_exit from "../../../../assets/icons/login-x-icon.svg";
import {
  addPopup,
  getUserData,
  sendAppLinkSms,
  addToken,
  addItem,
  getAvailabaleCoupons,
} from "../../../../redux/actions";
import { connect } from "react-redux";
import * as popups from "../../../../constants/popup-types";
import Loader from "../../../../components/common/loader";

class AddCreditCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      animation_class: "",
      popup_id: this.props.popup_id,
      newUrl: "",
    };
    this.animateOut = this.animateOut.bind(this);
    this.animateIn = this.animateIn.bind(this);
  }

  /* add class for animation after it is inserted into the DOM */
  componentDidMount() {
    this.animateIn();
    this.props.addToken();

    window.addEventListener(
      "message",
      (e) => {
        if ( e.origin === window.location.origin || e.origin.endsWith("hot.co.il")  ) {
          const result = e.data;
          if (result.from !== "hot") return;
          if (result.status === "success") {
            this.props.handleClose();
            this.props.getUserData();
            setTimeout(() => {
              if (['800', '1300'].includes(this.props.benefitType)) {
                // if paid coupon type
                this.props.action();
              } else {
                this.props.addItem({
                  benefitId: this.props.benefitId,
                  cda: this.props.cda,
                  amount: 1,
                });
              }
            }, 1000);
          } else {
            this.setState({ newUrl: result.url });
            this.props.addPopup({
              type: popups.GENERAL_MESSAGE,
              text: result.description,
            });
          }
        }
      },
      false
    );
  }

  componentWillUnmount() {}

  animateIn() {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.setState({ animation_class: "active" });
      });
    });
  }

  /* first remove the active class for exit animation then call the callback */
  animateOut(callback) {
    this.setState({ animation_class: "" });
    setTimeout(() => {
      if (callback) {
        callback(this.state.selected_id);
      }
      this.props.handleClose();
    }, 200);
  }

  render() {
    let telecard_url = this.props.telecard_url;
    let newUrl = this.state.newUrl;
    let translations = this.props.translations;
    return (
      <div
        className={"backdrop " + this.state.animation_class}
        onClick={() => this.animateOut()}
      >
        <div
          className={
            "popup_wrapper address_popup " + this.state.animation_class
          }
          onClick={(e) => e.stopPropagation()}
        >
          <div className="popup_content">
            <button className="x_close_icon" onClick={() => this.animateOut()}>
              <img src={desktop_exit} alt="" />
            </button>

            {/*<div className="wrapper">*/}
            {/*    <img src={getMediaPath(card) } alt='' className="icon" />*/}
            {/*    <span className="title">{translations['personal_zone_payment_methods']}</span>*/}
            {/*</div>*/}

            <Fragment>
              {!telecard_url && <Loader />}
              {telecard_url && (
                <iframe
                  className="tc-form"
                  referrerPolicy="strict-origin-when-cross-origin"
                  src={newUrl ? newUrl : telecard_url}
                  title="cg-iframe"
                />
              )}
            </Fragment>
          </div>
        </div>
      </div>
    );
  }
}

//connect to redux store
const mapStateToProps = (store) => {
  return {
    deviceState: store.state.deviceState,
    text: store.config.PopTrans,
    appDownStatus: store.data.AppDown,
    PopTrans: store.config.PopTrans,
    telecard_url: store.data.TelecardUrl,
    translations: store.config.Translations,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    sendAppLinkSms: (payload) => dispatch(sendAppLinkSms(payload)),
    addToken: (payload) => dispatch(addToken(payload)),
    addItem: (payload) => dispatch(addItem(payload)),
    addPopup: (payload) => dispatch(addPopup(payload)),
    getUserData: () => dispatch(getUserData()),
    getAvailableCoupons: (payload) => dispatch(getAvailabaleCoupons(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps, null, {
  pure: false,
})(AddCreditCard);
